import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import GatewaysViewModel from "../../../viewModels/enforcement/gateways/gatewaysViewModel";
import ListView from "../../common/list";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type GatewayResponse from "entities/gatewayResponse";
import GateWaysFilters from "./gatewaysFilters";

const GatewaysView: ViewComponent<GatewaysViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<GatewayResponse>[] = [
    {
      title: vm.translateAttribute("externalGatewayIdent"),
      property: "externalGatewayIdent",
    },
    {
      title: vm.translateAttribute("description"),
      property: "description",
    },
    {
      title: vm.translateAttribute("roadId"),
      property: "roadId",
      valueFormatter: props => vm.roadName(props.value),
    },
    {
      title: vm.translateAttribute("kilometerMarker"),
      property: "kilometerMarker",
    },
    {
      title: vm.translateAttribute("regionId"),
      property: "regionId",
      valueFormatter: props => vm.regionName(props.value),
    },
    {
      title: vm.translateAttribute("municipalityId"),
      property: "municipalityId",
      valueFormatter: props => vm.municipalityName(props.value),
    },
    {
      title: vm.translateAttribute("isDeleted"),
      property: "isDeleted",
      valueFormatter: props => (props.value ? vm.translateGeneral("boolean.true") : vm.translateGeneral("boolean.false")),
    },
  ];
  return <ListView vm={vm} columns={columns} aboveTable={<GateWaysFilters vm={vm} />} />;
});

registerView(GatewaysView, GatewaysViewModel);
